import { render, staticRenderFns } from "./FlexRewardEditor.vue?vue&type=template&id=6e186ff0&scoped=true"
import script from "./FlexRewardEditor.vue?vue&type=script&lang=ts"
export * from "./FlexRewardEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e186ff0",
  null
  
)

export default component.exports